import { ProductResource } from './resources.model';

export const productResourcesMock: ProductResource[] = [
  {
    type: 'OUTLINE',
    value: '16986000ME',
    url: '',
  },

  {
    type: 'CONNECTION',
    value: '00546501ME',
    url: '',
  },

  {
    type: 'CERTIFICATION',
    value: '',
    url: '',
  },

  {
    type: 'CAD Template',
    value: '16986000ME',
    url: '',
  },

  {
    type: 'PERFORMANCE',
    value: '',
    url: '',
  },

  {
    type: '3D CAD',
    value: 'File size requires longer download time',
    url: '',
  },

  {
    type: 'DataPack',
    value: '',
    url: '',
  },

  {
    type: 'CE Declaration',
    value: '',
    url: '',
  },
];
